module.exports = __webpack_public_path__ + "img/descImg5.21582252.png";